import { render, staticRenderFns } from "./ProjectCommissionConfirm.vue?vue&type=template&id=03bdc690&scoped=true"
import script from "./ProjectCommissionConfirm.vue?vue&type=script&lang=js"
export * from "./ProjectCommissionConfirm.vue?vue&type=script&lang=js"
import style0 from "./ProjectCommissionConfirm.vue?vue&type=style&index=0&id=03bdc690&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bdc690",
  null
  
)

export default component.exports